const actions = {
  FILTER_ORDER_BEGIN: 'FILTER_ORDER_BEGIN',
  FILTER_ORDER_SUCCESS: 'FILTER_ORDER_SUCCESS',
  FILTER_ORDER_ERR: 'FILTER_ORDER_ERR',

  SET_ORDER_FILTER_RANGE: 'SET_ORDER_FILTER_RANGE',
  SET_ORDER_FILTER_COLUMN: 'SET_ORDER_FILTER_COLUMN',
  RESET_SET_ORDER_FILTERS: 'RESET_SET_ORDER_FILTERS',

  EDIT_ORDER_ITEM_CUSTOMIZATION_JSON_BEGIN: 'EDIT_ORDER_ITEM_CUSTOMIZATION_JSON_BEGIN',
  EDIT_ORDER_ITEM_CUSTOMIZATION_JSON_SUCCESS: 'EDIT_ORDER_ITEM_CUSTOMIZATION_JSON_SUCCESS',
  EDIT_ORDER_ITEM_CUSTOMIZATION_JSON_ERROR: 'EDIT_ORDER_ITEM_CUSTOMIZATION_JSON_ERROR',

  RE_GENERATE_PDF_BEGIN: 'RE_GENERATE_PDF_BEGIN',
  RE_GENERATE_PDF_SUCCESS: 'RE_GENERATE_PDF_SUCCESS',
  RE_GENERATE_PDF_ERROR: 'RE_GENERATE_PDF_ERROR',

  UPDATE_ORDER_STATUS_BEGIN: 'UPDATE_ORDER_STATUS_BEGIN',
  UPDATE_ORDER_STATUS_SUCCESS: 'UPDATE_ORDER_STATUS_SUCCESS',
  UPDATE_ORDER_STATUS_ERROR: 'UPDATE_ORDER_STATUS_ERROR',

  GET_ALL_ORDERS_BEGIN: 'GET_ALL_ORDERS_BEGIN',
  GET_ALL_ORDERS_SUCCESS: 'GET_ALL_ORDERS_SUCCESS',
  GET_ALL_ORDERS_ERR: 'GET_ALL_ORDERS_ERR',

  GET_ALL_ORDER_STATUS_BEGIN: 'GET_ALL_ORDER_STATUS_BEGIN',
  GET_ALL_ORDER_STATUS_SUCCESS: 'GET_ALL_ORDER_STATUS_SUCCESS',
  GET_ALL_ORDER_STATUS_ERR: 'GET_ALL_ORDER_STATUS_ERR',

  GET_SINGLE_ORDER_BEGIN: 'GET_SINGLE_ORDER_BEGIN',
  GET_SINGLE_ORDER_SUCCESS: 'GET_SINGLE_ORDER_SUCCESS',
  GET_SINGLE_ORDER_ERR: 'GET_SINGLE_ORDER_ERR',
  SINGLE_ORDER_CLEAR: 'SINGLE_ORDER_CLEAR',

  EDIT_ORDER_ADDRESS_BEGIN: 'EDIT_ORDER_ADDRESS_BEGIN',
  EDIT_ORDER_ADDRESS_SUCCESS: 'EDIT_ORDER_ADDRESS_SUCCESS',
  EDIT_ORDER_ADDRESS_ERR: 'EDIT_ORDER_ADDRESS_ERR',

  getSingleOrderBegin: () => {
    return {
      type: actions.GET_SINGLE_ORDER_BEGIN,
    };
  },
  getSingleOrderSuccess: (data) => {
    return {
      type: actions.GET_SINGLE_ORDER_SUCCESS,
      data,
    };
  },
  getSingleOrderErr: (err) => {
    return {
      type: actions.GET_SINGLE_ORDER_ERR,
      err,
    };
  },

  singleOrderClear: () => {
    return {
      type: actions.SINGLE_ORDER_CLEAR,
    };
  },

  editOrderAddressBegin: () => {
    return {
      type: actions.EDIT_ORDER_ADDRESS_BEGIN,
    };
  },

  editOrderAddressSuccess: (data) => {
    return {
      type: actions.EDIT_ORDER_ADDRESS_SUCCESS,
      data,
    };
  },

  editOrderAddressErr: (err) => {
    return {
      type: actions.EDIT_ORDER_ADDRESS_ERR,
      err,
    };
  },

  getAllOrdersBegin: () => {
    return {
      type: actions.GET_ALL_ORDERS_BEGIN,
    };
  },
  getAllOrdersSuccess: (data) => {
    return {
      type: actions.GET_ALL_ORDERS_SUCCESS,
      data,
    };
  },
  getAllOrdersErr: (err) => {
    return {
      type: actions.GET_ALL_ORDERS_ERR,
      err,
    };
  },

  getAllOrderStatusBegin: () => {
    return {
      type: actions.GET_ALL_ORDER_STATUS_BEGIN,
    };
  },
  getAllOrderStatusSuccess: (data) => {
    return {
      type: actions.GET_ALL_ORDER_STATUS_SUCCESS,
      data,
    };
  },
  getAllOrderStatusErr: (err) => {
    return {
      type: actions.GET_ALL_ORDER_STATUS_ERR,
      err,
    };
  },

  filterOrderBegin: () => {
    return {
      type: actions.FILTER_ORDER_BEGIN,
    };
  },

  filterOrderSuccess: (data) => {
    return {
      type: actions.FILTER_ORDER_SUCCESS,
      data,
    };
  },

  filterOrderErr: (err) => {
    return {
      type: actions.FILTER_ORDER_ERR,
      err,
    };
  },

  setOrderFilterRange: (start, end) => {
    return {
      type: actions.SET_ORDER_FILTER_RANGE,
      start,
      end,
    };
  },

  setOrderFilterColumn: (column, value) => {
    return {
      type: actions.SET_ORDER_FILTER_COLUMN,
      column,
      value,
    };
  },

  resetOrderFilters: () => {
    return {
      type: actions.RESET_SET_ORDER_FILTERS,
    };
  },

  editOrderItemCustomizationJsonBegin: () => {
    return {
      type: actions.EDIT_ORDER_ITEM_CUSTOMIZATION_JSON_BEGIN,
    };
  },
  editOrderItemCustomizationJsonSuccess: () => {
    return {
      type: actions.EDIT_ORDER_ITEM_CUSTOMIZATION_JSON_SUCCESS,
    };
  },
  editOrderItemCustomizationJsonError: () => {
    return {
      type: actions.EDIT_ORDER_ITEM_CUSTOMIZATION_JSON_SUCCESS,
    };
  },

  reGeneratePdfBegin: (orderItemId) => {
    return {
      type: actions.RE_GENERATE_PDF_BEGIN,
      orderItemId,
    };
  },
  reGeneratePdfSuccess: (orderItemId) => {
    return {
      type: actions.RE_GENERATE_PDF_SUCCESS,
      orderItemId,
    };
  },
  reGeneratePdfError: (orderItemId) => {
    return {
      type: actions.RE_GENERATE_PDF_ERROR,
      orderItemId,
    };
  },

  updateOrderStatusBegin: () => {
    return {
      type: actions.UPDATE_ORDER_STATUS_BEGIN,
    };
  },
  updateOrderStatusSuccess: () => {
    return {
      type: actions.UPDATE_ORDER_STATUS_SUCCESS,
    };
  },
  updateOrderStatusError: () => {
    return {
      type: actions.UPDATE_ORDER_STATUS_ERROR,
    };
  },
};

export default actions;
